import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import { showError, showSuccess } from "ReduxErrorBar";
import { redundModalCall, refundOrder } from "TicketAction";
import { IMAGE_PATH, STRIPE_FEE_EXTRA, COMMON_FAIL_MESSAGE } from "Constants";
import OrderRefundTicketItems from "./order-refund-ticket-item";
import LocaleStrings from "Languages";

class OrderRefund extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, selectedItems: [], allCheck: false };

    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    this.props.redundModalCall({ show: false });
    this.setState({ selectedItems: [] });
  }

  refundTickets = () => {
    let { session, showModal } = this.props;
    let { selectedItems } = this.state;
    let order = showModal.orderDetails;
    let ticketQuantity = order.total_quantity;
    console.log("selectedItems :- ", selectedItems);

    let refundTic = [];
    _.map(selectedItems, (o) => {
      refundTic.push({ ticketid: o.ticketid, position: o.position });
    });

    if (refundTic.length === ticketQuantity) {
      refundTic = "all";
    }

    let payload = { orderid: order.id, deleteto: refundTic };

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body">
            <h1>
              {LocaleStrings.tickets_salesreport_refund_confirmation_title}
            </h1>
            <p>
              {LocaleStrings.tickets_salesreport_refund_confirmation_subtitle}
            </p>

            <div className="react-confirm-alert-button-group">
              <button
                type="button"
                onClick={() => {
                  onClose();
                  this.setState({ loading: true });
                  this.props.refundOrder(session, payload, (response) => {
                    console.log("response :- ", response);
                    if (response.success === 1) {
                      this.props.refreshOrder();

                      setTimeout(() => {
                        this.props.showSuccess(
                          LocaleStrings.tickets_salesreport_refund_success
                        );
                        this.setState({ loading: false });
                        this.closeModal();
                      }, 500);
                    } else if (response.success === 2) {
                      this.props.showError(response.message);
                      this.setState({ loading: false });
                    } else {
                      this.props.showError(COMMON_FAIL_MESSAGE);
                      this.setState({ loading: false });
                    }
                  });
                }}
              >
                {LocaleStrings.button_ok}
              </button>
              <button onClick={onClose}>{LocaleStrings.button_cancel}</button>
            </div>
          </div>
        );
      },
    });
  };

  // Selecting one one item
  updateSelectedItem = (item, position) => {
    var selectedItems = this.state.selectedItems;
    var index = _.findIndex(selectedItems, function (curitem) {
      return (
        curitem.ticketid === item.ticketid && curitem.position === position
      );
    });

    if (index >= 0) {
      var newSelectedItems = [];
      _.map(selectedItems, (selitem, i) => {
        if (
          selitem.ticketid === item.ticketid &&
          selitem.position === position
        ) {
        } else {
          newSelectedItems.push(selitem);
        }
      });

      this.checkMatchArray(newSelectedItems);
      this.setState({ selectedItems: newSelectedItems });
    } else {
      var newSelectUser = { ...item, checked: true, position: position };
      selectedItems = [...selectedItems, newSelectUser];

      this.checkMatchArray(selectedItems);
      this.setState({ selectedItems });
    }
  };

  // Here we are looping to show tickets which are visiable on screen only
  selectAllItems = () => {
    let { showModal } = this.props;
    let order = showModal.orderDetails;
    var state = this.state.allCheck;
    var selectedItems = this.state.selectedItems;
    let orderDetails = order.orderdetails_by_orderid;

    var newSelectUser = [];
    var newSelectedItems = [];

    if (state == false) {
      _.map(orderDetails, (item) => {
        let ticketQuantity = item.quantity;

        for (let index = 0; index < ticketQuantity; index++) {
          var checkItemExitOrNot = _.filter(selectedItems, function (selitem) {
            return (
              selitem.ticketid === item.ticketid && selitem.position === index
            );
          });

          // Check if item is not exist in selected item that add
          if (checkItemExitOrNot.length == 0) {
            newSelectUser = { ...item, checked: true, position: index };
            selectedItems = [...selectedItems, newSelectUser];
          }

          this.checkMatchArray(selectedItems);
          this.setState({ selectedItems });
        }
      });
    } else {
      var leftItems = selectedItems;
      _.map(orderDetails, (item) => {
        let ticketQuantity = item.quantity;

        for (let index = 0; index < ticketQuantity; index++) {
          _.map(leftItems, (selitem, i) => {
            if (
              selitem.ticketid === item.ticketid &&
              selitem.position === index
            ) {
            } else {
              newSelectedItems.push(selitem);
            }
          });
          leftItems = newSelectedItems;

          this.checkMatchArray(leftItems);
          this.setState({ selectedItems: leftItems });
        }
      });
    }
  };

  // This function is used to check or uncheck master check field
  checkMatchArray = (selected) => {
    setTimeout(() => {
      let { showModal } = this.props;
      let order = showModal.orderDetails;
      let orderDetails = order.orderdetails_by_orderid;

      var newArray = [];
      _.map(orderDetails, (item) => {
        let ticketQuantity = item.quantity;

        for (let index = 0; index < ticketQuantity; index++) {
          var newSelectedItems = _.filter(selected, function (selitem) {
            return (
              selitem.ticketid === item.ticketid && selitem.position === index
            );
          });

          if (newSelectedItems && newSelectedItems.length > 0) {
            // newArray = [...newArray, newSelectedItems];
            newArray.push(newSelectedItems[0]);
          }
        }
      });

      // Check for all user selected or not according to that check or uncheck master check option
      let totalTickets = _.sumBy(orderDetails, "quantity");
      if (newArray.length > 0 && newArray.length === totalTickets) {
        this.setState({ allCheck: true });
      } else {
        this.setState({ allCheck: false });
      }
    }, 100);
  };

  renderTickets = () => {
    let { showModal } = this.props;
    let order = showModal.orderDetails;
    let orderDetails = order.orderdetails_by_orderid;
    let ticketQty = 0;

    return _.map(orderDetails, (item, index) => {
      ticketQty = ticketQty + item.quantity;

      return (
        <OrderRefundTicketItems
          key={`orderitems_${index}`}
          item={item}
          order={order}
          checkAndUncheckItem={this.updateSelectedItem}
          selectedItems={this.state.selectedItems}
          ticketQty={ticketQty}
        />
      );
    });
  };

  render() {
    let { showModal, stripeCurrencyDetailsList } = this.props;
    let { loading, allCheck } = this.state;
    let order = showModal.orderDetails;
    let currency = order.currency;

    // Get Fee charges values
    let matchFee = _.filter(stripeCurrencyDetailsList, (obj) => {
      return obj.currency === currency;
    });
    console.log("matchFee :- ", matchFee);
    let stripeExtraFee =
      matchFee.length > 0 ? matchFee[0].stripe_fixed : STRIPE_FEE_EXTRA;

    return (
      <div>
        <Modal
          className="modal-container"
          show={showModal.show === true ? true : false}
          onHide={this.closeModal}
          animation={true}
          dialogClassName="size600PxModal"
        >
          <Modal.Header>
            <div className="import-modal-title">
              {LocaleStrings.tickets_salesreport_refund_modal_title}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.closeModal()}
            >
              <img
                className="i-custom-small"
                src={`${IMAGE_PATH}custom-icons/cross-black.png`}
                alt="cross"
              />
            </button>
          </Modal.Header>
          <Modal.Body>
            {/* Order Details */}
            <div className="custom-text1-primary-medium">
              OrderRef : {order.orderid}
            </div>

            {/* Order Tickets Details */}
            <table className="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>
                    <label className="custom-container-checkbox">
                      <input
                        type="checkbox"
                        onChange={this.selectAllItems}
                        checked={allCheck}
                      />
                      <span className="checkmark" />
                    </label>
                  </th>
                  <th>TicketName</th>
                  <th>TicketPrice</th>
                </tr>
              </thead>
              <tbody>{this.renderTickets()}</tbody>
            </table>

            {/* <div className="vertical-align-center-justify-right">
              {allCheck ? (
                <>
                  This Fee will applied when full order will refunded &nbsp;
                  {stripeExtraFee}
                </>
              ) : (
                ""
              )}
            </div> */}
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-custom-blue"
              onClick={this.refundTickets}
              loading={loading}
              disabled={loading}
              type="button"
            >
              {LocaleStrings.button_refund}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    showModal: state.refundModalShow,
    stripeCurrencyDetailsList: state.stripeCurrencyDetailsList,
  };
}

export default connect(mapStateToProps, {
  redundModalCall,
  refundOrder,
  showError,
  showSuccess,
})(OrderRefund);
